/**
 * App shell UI preferences (nav rail lock, etc.) — skeleton API.
 * Replace with GET/PATCH /users/me/preferences.
 */

const STORAGE_NAV_RAIL_LOCKED = "sample-ui:nav-rail-locked:v1";

const stubDelay = (ms = 12) => new Promise((r) => setTimeout(r, ms));

/**
 * Synchronous read — used as useState initializer to avoid a narrow → wide jerk on mount.
 * @returns {boolean}
 */
export function readNavRailLockedSync() {
  if (typeof window === "undefined") return false;
  try {
    const raw = window.localStorage.getItem(STORAGE_NAV_RAIL_LOCKED);
    if (raw == null) return false;
    return Boolean(JSON.parse(raw)?.locked);
  } catch {
    return false;
  }
}

/**
 * @returns {Promise<{ data: { locked: boolean } }>}
 */
export async function getNavRailLocked() {
  await stubDelay();
  if (typeof window === "undefined") return { data: { locked: false } };
  try {
    const raw = window.localStorage.getItem(STORAGE_NAV_RAIL_LOCKED);
    if (raw == null) return { data: { locked: false } };
    const parsed = JSON.parse(raw);
    return { data: { locked: Boolean(parsed?.locked) } };
  } catch {
    return { data: { locked: false } };
  }
}

/**
 * @param {{ locked: boolean }} payload
 */
export async function saveNavRailLocked(payload) {
  await stubDelay();
  try {
    window.localStorage.setItem(STORAGE_NAV_RAIL_LOCKED, JSON.stringify({ locked: !!payload.locked }));
  } catch {
    /* ignore */
  }
  return { data: { ok: true, locked: !!payload.locked } };
}
